export const ColorContrasteMixin = {
  methods: {
    colorContraste(hex) {
      if (!hex) return '#000';
      let c = hex.replace('#', '');
      if (c.length === 3) {
        c = c.split('').map(ch => ch + ch).join('');
      }
      const r = parseInt(c.substring(0, 2), 16);
      const g = parseInt(c.substring(2, 4), 16);
      const b = parseInt(c.substring(4, 6), 16);
      const yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 128 ? '#000' : '#fff';
    }
  }
};
